import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'

function FormBrands__BrandDetails(props) {
    const { formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Brand Name"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Brand Name"} // placeholder for the input
                formikFieldName={"brandName"} // important: formik value name for the input
            />

        </React.Fragment>
    )
}

export default memo(FormBrands__BrandDetails)